import React from "react";
import { useUserStore } from "../../_store/userStore";
import api from "../../api/api.main";
import LineLoginIcon from "../../components/icon/lineloginIcon";
import { useNavigate } from "react-router-dom";

const PremiumInfo = () => {
  const userData = useUserStore((state) => state.userData);
  const navigate = useNavigate();

  return (
    <div
      style={{
        backgroundImage: `url(/images/circle.png)`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "left 60%",
      }}
      className="bg-white min-h-screen font-IBMPlexSansThai mt-[79px] pt-[36px] px-[32px] "
    >
      {/* Main Content */}
      <main className="max-w-screen-lg mx-auto px-4 py-8">
        {/* Section 1: Title and Description */}
        <section className="mb-[18px]">
          <h1 className="text-2xl font-bold text-[#18488A] mb-2">
            สมัครวางแผนการเงินองค์รวม
          </h1>
          <p className="text-base">
            ให้ชีวิตทางการเงินของคุณเป็นเรื่องง่าย ๆ
            <br />
            ด้วยแผนทางการเงินที่ครอบคลุม
          </p>
        </section>

        {/* Section 2: Image with Text */}
        <section className="mb-[18px]">
          <div className="relative overflow-hidden rounded-[20px] aspect-[326/140] mb-[30px] ">
            <img
              src="/images/family_premium_info.jpg"
              alt="Family enjoying together"
              className="w-full h-full object-cover "
            />
          </div>
          <div className="mt-4">
            <h2 className="text-xl font-bold text-end text-[#18488A] mb-2">
              ผู้เชี่ยวชาญด้านการเงิน
            </h2>
            <p className="text-end ">
              เราพร้อมเป็นเพื่อนที่ช่วยปรึกษา
              <br />
              แผนการเงินที่เหมาะสมกับคุณ
            </p>
          </div>
        </section>

        {/* Section 3: Image with Text */}
        <section className="">
          <div className="relative overflow-hidden rounded-[20px] aspect-[326/140] mb-[30px] ">
            <img
              src="/images/business_calculing_premium_info.jpg"
              alt="Financial planning"
              className="w-full h-full object-cover"
            />
          </div>
        </section>

        {/* Section 4: Pricing and CTA */}
        <section className="mb-8 bg-[#F4F2F3] relative rounded-[20px] pb-[24px] ">
          <div className="bg-[#FFD200] w-fit font-semibold text-[16px] text-white px-[42px] py-[2px] rounded-full absolute left-[50%] translate-y-[-50%] translate-x-[-50%] ">
            SPECIAL
          </div>
          <p className="text-center mb-4 text-[16px] pt-[24px] ">
            เพียงฝันในการเงินให้เป็นจริง
            <br />
            ด้วยแผนการเงินที่มีประสิทธิภาพ
            <br />
            ได้รับสิทธิพิเศษจากนักวางแผนการเงิน CFP® ฟรี 1 ครั้ง ครึ่งชั่วโมง
          </p>
          <h3 className="text-3xl font-semibold text-center text-[#18488A] mb-4">
            3,959 บาท / ปี
          </h3>
          <button
            onClick={async () => {
              try {

                if (!userData?._id ) {
                  navigate("/login");
                  return;
                }

                const { data } = await api.post(
                  `/services/stripe/create-session`,
                  {
                    profile_id: userData?._id,
                    email: userData?.email,
                  }
                );

                window.location.href = data?.url;
              } catch (error) {
                console.log("preimum error", error);
              }
            }}
            className="block mx-auto bg-[#00A9A0]  text-white px-[54px] py-[5.5px] rounded-full font-semibold "
          >
            อัพเกรดเลยตอนนี้
          </button>
        </section>

        <section className="mb-8 bg-[#F4F2F3] text-[#18488A] relative rounded-[20px] pb-[24px] ">
          <p className="text-center mb-4 text-[16px] pt-[24px] ">
            สำหรับองค์กรที่ต้องการสมัครสมาชิก
            <br />
            จำนวนมาก ทางเรามีโปรโมชั่นพิเศษ
            <br />
            กรุณาแอดไลน์
          </p>
          <button
            onClick={async () => {
              window?.open(
                "https://liff.line.me/1645278921-kWRPP32q/?accountId=assurewealth"
              );
            }}
            className="flex flex-row items-center mx-auto bg-[#00A9A0] text-white px-[30px] py-[5.5px] rounded-full font-semibold "
          >
            <LineLoginIcon className={`w-5 h-5 mr-2`} />
            Assure Walth
          </button>
        </section>
      </main>
    </div>
  );
};

export default PremiumInfo;
